export const environment = {
  production: true,
  apiUrl: 'https://gacad.udg.edu/trasllats_backend/api/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts